// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** BASIC DETAILS ADD START *********************** */
export const basicMemberDetailsAdd = (verifyData: any) => {
	const data = {
		CreateMemberDetailsToken: verifyData,
	};
	const url = `${API_URL}addBasicDetails`;
	return makeApiCall(url, data);
};
/** ***************** BASIC DETAILS ADD END *********************** */
